/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICRTouchConnection } from './ICRTouchConnection';
import {
    ICRTouchConnectionFromJSON,
    ICRTouchConnectionFromJSONTyped,
    ICRTouchConnectionToJSON,
    ICRTouchConnectionToJSONTyped,
} from './ICRTouchConnection';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';

/**
 * 
 * @export
 * @interface ListIcrTouchConnectionsResponse
 */
export interface ListIcrTouchConnectionsResponse {
    /**
     * 
     * @type {Array<ICRTouchConnection>}
     * @memberof ListIcrTouchConnectionsResponse
     */
    data: Array<ICRTouchConnection>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListIcrTouchConnectionsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListIcrTouchConnectionsResponse interface.
 */
export function instanceOfListIcrTouchConnectionsResponse(value: object): value is ListIcrTouchConnectionsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListIcrTouchConnectionsResponseFromJSON(json: any): ListIcrTouchConnectionsResponse {
    return ListIcrTouchConnectionsResponseFromJSONTyped(json, false);
}

export function ListIcrTouchConnectionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListIcrTouchConnectionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ICRTouchConnectionFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListIcrTouchConnectionsResponseToJSON(json: any): ListIcrTouchConnectionsResponse {
      return ListIcrTouchConnectionsResponseToJSONTyped(json, false);
  }

  export function ListIcrTouchConnectionsResponseToJSONTyped(value?: ListIcrTouchConnectionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ICRTouchConnectionToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

